module.exports = __webpack_public_path__ + "img/Mstorybg3.e3b04a42.jpg";